import { EventInfo } from '../types';
import { Track } from './Track';
import { browserInstance as browser } from '@/utils/browser';

// 从这里拷出来的 '@mkt-common/shopee-common'
export function scriptsLoadStatus() {
  if (browser.shopeeAppOrLiveChat) { // window.WebViewJavascriptBridge只在shopee app中初始化
    // @ts-ignore
    return !!(window.bridgeInit && window.connectWebViewJavascriptBridge && window.WebViewJavascriptBridge);
  } else {
    // @ts-ignore
    return !!(window.bridgeInit && window.connectWebViewJavascriptBridge);
  }
}

// 从这里拷出来的 '@mkt-common/shopee-common'
export function trackBIShopeeApp(eventDataList: any) {
  if (scriptsLoadStatus()) {
    window.bridgeInit(() => {
      window.bridgeCallHandler('trackBIEvent', { events: JSON.stringify(eventDataList) });
    });
  }
}

export class AppBITrack extends Track {
  /**
   * Creates an instance of AppBITrack.
   * @param {{ isReact: boolean, isPC: boolean }}
   */
  constructor({ isReact, isPC }: { isReact: boolean, isPC: boolean }) {
    super({ isReact, isPC });
  }

  /**
   * 埋点方法
   *
   * @param {EventInfo} info
   * @memberof AppBITrack
   */
  report(info: EventInfo) {
    const eventData = this._generateEventData(info);
    trackBIShopeeApp([eventData]);
  }
}
